import { claimManagerTvlFees } from "@bracket/contractor-next/bracket-vault";
import { isBlockHash } from "@bracket/types";
import type { ResolverResult } from "@types";
import { isUserWalletRejection } from "@utils";
import { wagmiConfig as config } from "@wagmiconfig";

/**
 * Processes a claim for manager TVL fees for a given vault address
 * @param address - The address of the vault to claim fees from
 * @returns A ResolverResult containing the transaction hash on success or error details on failure
 */
export const processClaimManagerTvlFees = async (
	address: string,
): Promise<ResolverResult> => {

	try {

		const hash = await claimManagerTvlFees({ vault: address, config });
		if(isBlockHash(hash)) {
			return {
				success: true,
				hash,
			};
		}

		throw new Error("processClaimManagerTvlFees failed to produce a valid blockhash");

	}
	catch (err) {
	
		if(isUserWalletRejection(err)) {
			return {
				success: false,
				rejected: true,
			};
		}

		return {
			success: false,
			rejected: false,
			error: err as Error,
		};

	}

};
